import { Head } from "@inertiajs/react";

// Browser-tab title only. Everything a crawler or social sharer reads —
// <title>, description, keywords, canonical, hreflang, Open Graph, Twitter and
// JSON-LD — is rendered server-side by Rails (app/services/insights/
// seo_presenter.rb via app/views/shared/_page_seo.html.erb), because Inertia
// SSR is disabled and non-JS crawlers only ever see the server HTML.
//
// Do not re-add <meta name="description"> (or og/twitter/canonical) here.
// Inertia's head manager only removes head elements it tagged itself: it
// collects its removal set from the data-inertia attribute, so the Rails-
// emitted description never matches and the client copy is APPENDED — the page
// then ships two conflicting descriptions. See headManager.update in
// @inertiajs/core. <title> is the single exception the manager special-cases:
// it deletes `title:not([data-inertia])` outright, so whatever is passed here
// replaces the server's title and must agree with what the server sent.
const SeoHead = (props) => {
  const { title } = props;

  return <Head title={title} />;
};

export default SeoHead;
